import { RegionT } from "pytha";
import { HSL } from "three";

export class MonitorColorRegionT extends RegionT {

    type: string = "MonitorColorRegionT";

    _getRenderColor() {
        let colorClone = this.color.clone();
        if (!!this._isLock) {
            // 锁定的时候将颜色变暗
            let hsl: HSL = { h: 0, s: 0, l: 0 };
            this.color.getHSL(hsl);
            hsl.l = 1 - (1 - hsl.l) / this.context.renderContext.lockColorDown;
            colorClone.setHSL(hsl.h, hsl.s, hsl.l);
        } else if (this.isSelected) {
            //选中逻辑改为变色
            colorClone.set("#00F0FF")
        }
        return colorClone;
    }
}

